exports = module.exports = require("../../../../../../../../../../usr/lib/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".besidaMob-banNotification__root--1VO4Y{padding:15px 10px 10px;text-align:center}.besidaMob-banNotification__text--xzG4b{font-size:14px;margin:0 0 15px}", ""]);

// exports
exports.locals = {
	"root": "besidaMob-banNotification__root--1VO4Y",
	"text": "besidaMob-banNotification__text--xzG4b"
};